import { css } from 'lit';
export const ProfileDisplayCss = css `
    .profile-container {
        position: relative;
        border-radius: 50%;
        cursor: pointer;
        overflow: hidden;
        border: 3px solid #dddfe2;
        margin: 0 auto;
        background-color: #f0f2f5;
        transition: border-color 0.2s ease-in-out;
    }
    .profile-container.dragging-over {
        border-color: #1877f2;
    }
    .preview-media, .default-avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    .default-avatar {
        fill: #a9a9a9;
        padding: 15%; /* Make default icon smaller than container */
        box-sizing: border-box;
    }
    .overlay {
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s ease;
    }
    .profile-container:hover .overlay {
        opacity: 1;
    }
    .camera-icon {
        width: 30%;
        height: 30%;
        color: white;
        stroke: white;
        stroke-width: 1.5;
        fill: none;
    }
    .profile-container .loader {
        width: 30%; height: 30%;
        border: 5px solid rgba(255,255,255,0.3);
        border-top-color: white;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
    @keyframes spin { 100% { transform: rotate(360deg); } }
`;
